import { memo } from "react";
import type { IconProps } from "types";

const ArrowRight = ({ color = "white", width = "15", height = "16", onClick = () => {} }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_41_1263)">
        <path d="M15 0.5H0V15.5H15V0.5Z" fill="white" fillOpacity="0.01" />
        <path d="M13.125 8H1.875" stroke={color} strokeWidth="1.03448" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M9.375 4.25L13.125 8L9.375 11.75"
          stroke={color}
          strokeWidth="1.03448"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_1263">
          <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(ArrowRight);
